import React, { Component } from "react";
import { Button, Accordion } from "react-bootstrap";

class LeaveCard extends Component {
  render() {
    return (
      <div className="border shadow-sm rounded mb-3 p-3">
        <Accordion defaultActiveKey={null}>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey="1"
            style={{
              padding: 0,
              textDecoration: "none",
              boxShadow: "none",
              width: "100%",
            }}
          >
            <div className="th-14 th-medium th-cap th-black text-left">
              {this.props.title}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="th-12 th-grey text-left">Leave Details</div>

              <i className="fa fa-angle-down th-primary" aria-hidden="true"></i>
            </div>
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="1">
            <div className="mt-2">
              <div className="d-flex justify-content-between align-items-center">
                <div className="th-12 th-black text-left th-grey">
                  From: {this.props.from}
                </div>
                <div className="th-12 th-black text-left th-grey">
                  To: {this.props.to}
                </div>
              </div>
              <div className="th-12 th-grey text-left pt-2">
                {this.props.description}
              </div>
              <div className="th-12 th-grey text-left pt-2">
                Status: {this.props.status}
              </div>
            </div>
          </Accordion.Collapse>
        </Accordion>
      </div>
    );
  }
}
export default LeaveCard;
